module.exports = __webpack_public_path__ + "img/9788952747419.81fa6bfb.jpg";